import { Injectable } from '@angular/core';

@Injectable({ providedIn: 'root' })
export class StorageService {

    preferencesKey = 'preferences';

    /**
     * Any
     * @param {string} key
     */
    any(key: string): boolean {
        return this.get(key) !== null;
    }

    /**
     * Get Item
     * @param {string} key
     */
    get(key: string): string | null {
        return localStorage.getItem(key);
    }

    /**
     * Set Item
     * @param {string} key
     * @param {string} value
     */
    set(key: string, value: string): void {
        localStorage.setItem(key, value);
    }

    /**
     * Set preferences item
     * @param {string} key
     * @param {string} value
     */
    setPreferences(key: string, value: string | boolean | number | object): void {
        let sessionData = {};
        const data = this.get(this.preferencesKey);
        if (data != null) { sessionData = JSON.parse(data); }

        sessionData[key] = value;
        this.set(this.preferencesKey, JSON.stringify(sessionData));
    }

    /**
     * Get preferences item
     * @param {any} key
     */
    getPreferences(key: string): any {
        const data = this.get(this.preferencesKey);
        return (data != null) ? JSON.parse(data)[key] : null;
    }

    /* clear */
    clear(): void {
        localStorage.clear();
    }
}
